export const API_BASE_URL = '/api';
export const BASE_URL = import.meta.env.BASE_URL.slice(0, -1) || '/';